import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useNavigate } from "react-router-dom";
import { getXLExecutionPlanDetails } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import keys from "../../utils/helpInfoKeys.json";
import { motion } from "motion/react";
import "./reports.css";
import Login from "../Login";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo";

const Executionplansummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const [shouldOpenPdf, setShouldOpenPdf] = useState(false);
  const strategyPlanData = useSelector((state) => state.strategyPlanData);
  const [biName, setBIName] = useState(null);
  const [productName, setProductName] = useState(null);
  const selectedBI = useSelector((state) => state.selectedBI);
  useEffect(() => {
    if (selectedBI) {
      setBIName(selectedBI.label);
      const product = localStorage.getItem("product_value");
      setProductName(product);
    }
  }, [selectedBI]);
  const [objective, setObjective] = useState("");
  const [goalList, setGoalList] = useState([]);
  const [functionsList, setFunctionList] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getXLExecutionPlanDetails(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id")
        )
      );
    }
  }, []);
  useEffect(() => {
    if (strategyPlanData) {
      setObjective(strategyPlanData?.objective[0]?.name);
      setGoalList(strategyPlanData.goals);
      const funList = strategyPlanData.functions;
      const removedGEMSFunctionalGoals = funList.map((item) => ({
        ...item,
        strategic_imperative: item?.strategic_imperative?.filter(
          (task) => task.is_system_generated_task === false
        ),
      }));
      setFunctionList(removedGEMSFunctionalGoals);
    }
  }, [strategyPlanData]);
  useEffect(() => {
    if (
      shouldOpenPdf &&
      strategyPlanData &&
      strategyPlanData.is_ecosystem_summary === true
    ) {
      const { pdf_base64 } = strategyPlanData;
      const pdfBlob = new Blob(
        [
          new Uint8Array(
            atob(pdf_base64)
              .split("")
              .map((char) => char.charCodeAt(0))
          ),
        ],
        { type: "application/pdf" }
      );
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, "_blank");
      setShouldOpenPdf(false);
    }
  }, [strategyPlanData, shouldOpenPdf]);

  const handleBack = () => {
    navigate("/ecosystemsummary", { replace: true });
  };

  const handleClick = () => {
    navigate("/projectanalytics", { replace: true });
  };
  const handlePrintEcosystemSummaryReport = () => {
    setShouldOpenPdf(true);
    dispatch(
      getXLExecutionPlanDetails(
        localStorage.getItem("bi_id"),
        localStorage.getItem("product_id"),
        "",
        "",
        true
      )
    );
  };

  const content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <div className="execution-reports-container">
        <div className="execution-reports-section">
          <h2 className="execution-reports-section-title">
            Execution Plan Summary
          </h2>
          {selectedHelpInfoSidebar && <SideNavHelpInfo />}
          <div style={{ width: "100%" }} className="strategyplansummary">
            <table className="execution-reports-table">
              <tbody>
                <tr>
                  <td
                    style={{ width: "35%" }}
                    className="execution-reports-sub-section"
                  >
                    <div
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      BI NAME:
                    </div>
                  </td>
                  <td
                    style={{ width: "65%" }}
                    className="execution-reports-sub-section"
                  >
                    <div
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      PRODUCT NAME:
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width={"35%"}>
                    <div style={{ fontSize: "var(--text-font-size)" }}>
                      {biName}
                    </div>
                  </td>
                  <td width={"65%"}>
                    <div style={{ fontSize: "var(--text-font-size)" }}>
                      {productName}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width={"35%"} className="execution-reports-sub-section">
                    <div
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      OBJECTIVE:
                    </div>
                  </td>
                  <td width={"65%"} className="execution-reports-sub-section">
                    <div
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      GOALS:
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "35%" }}>
                    <div style={{ fontSize: "var(--text-font-size)" }}>
                      {objective}
                    </div>
                  </td>

                  <td style={{ width: "65%" }}>
                    {goalList.map((goal, index) => (
                      <div
                        style={{
                          marginLeft: "20px",
                          fontSize: "var(--text-font-size)",
                        }}
                      >
                        {index + 1}
                        {"."}
                        {goal.name}
                      </div>
                    ))}
                  </td>
                </tr>
                <tr>
                  <td
                    className="execution-reports-sub-section"
                    style={{
                      width: "35%",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    FUNCTIONS:
                  </td>
                  <td
                    className="execution-reports-sub-section"
                    style={{
                      width: "65%",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    FUNCTIONAL GOALS & MILESTONES:
                  </td>
                </tr>
                {functionsList &&
                  functionsList.length > 0 &&
                  functionsList.map((obj, index) => (
                    <>
                      <tr className="execution-reports-child-row">
                        <td
                          style={{
                            fontSize: "var(--text-font-size)",
                            width: "35%",
                          }}
                        >
                          {obj.name}
                        </td>
                        <td
                          style={{
                            textAlign: "left",
                            paddingLeft: "5px",
                            width: "65%",
                          }}
                        >
                          {obj &&
                            obj.strategic_imperative.map((stImp, id) => (
                              <>
                                <div
                                  style={{
                                    fontSize: "var(--text-font-size)",
                                  }}
                                >
                                  {stImp.name}
                                </div>
                                {stImp &&
                                  stImp.milestones &&
                                  stImp.milestones.map((mile) => (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          fontSize: "var(--text-font-size)",
                                        }}
                                      >
                                        <div style={{ marginLeft: "20px" }}>
                                          {mile.name}
                                        </div>
                                        {mile.assigned_to &&
                                          mile.assigned_to
                                            .filter(
                                              (item) => item.is_active === true
                                            )
                                            .map((activeItem) => (
                                              <span key={activeItem.value} style={{ marginLeft: "10px" }}>
                                                ({activeItem.label})
                                              </span>
                                            ))}
                                        {mile.due_date && (
                                          <div style={{ marginLeft: "10px" }} >({mile.due_date})</div>
                                        )}
                                      </div>
                                    </>
                                  ))}
                              </>
                            ))}
                        </td>
                      </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </motion.div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <MainComponent
        maincontent={content}
        showSelector={true}
        showButtons={true}
        handleNext={handleClick}
        handleBackButton={handleBack}
        breadcrumbParent={"Reports"}
        showPrintButton={true}
        breadcrumbChild={"Execution Plan Summary"}
        handlePrintEcosystemSummaryReport={handlePrintEcosystemSummaryReport}
        showProducts={true}
        documentName={"Execution Plan Summary"}
        helpKey={keys["Execution Plan Summary"].Name}
        image={"none"}
      />
    );
  }
};

export default Executionplansummary;
